import { request } from "./fetch";

class ChatService {
  static async getUsersByChat(clinicaId) {
    return request(`api/chat/users?clinicaId=${clinicaId}`);
  }

  static async getUsuariosSocios(clinicaId) {
    return request(`api/chat/usuarios-socios?clinicaId=${clinicaId}`);
  }
}

export { ChatService };
